import { createReducer } from 'reduxsauce'
// import { Types } from 'store/actions/feedback'
// import { success } from 'utils/actions'

export const initialState = {}

const handlers = {}

export default createReducer(initialState, handlers)
